import { storageName } from '../utils/storage';
import Dexie from 'dexie';
import { indexedDbOperation } from '../utils/indexedDbOperation';

// Deliberately separate from NewsDatabase: refreshing the feed must never
// remove private local recordings. Blob URLs are only made while rendering.
const database = new Dexie(storageName('WiwRecordingDrafts'));
database.version(1).stores({ drafts: 'key, userId, updatedAt' });
export const mediaDraftKey = (userId, storyId, draftId) => `${userId}:${storyId}:${draftId}`;
export const readMediaDraft = key => indexedDbOperation(database, 'r', ['drafts'], () => database.drafts.get(key));
export const writeMediaDraft = draft => indexedDbOperation(database, 'rw', ['drafts'],
  () => database.drafts.put({ ...draft, updatedAt: Date.now() }));
export const deleteMediaDraft = key => indexedDbOperation(database, 'rw', ['drafts'], () => database.drafts.delete(key));
